var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSolicitors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86.5 104.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 2.61px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        stroke: #fff;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-9 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-8 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: .25;\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: .75;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-9 {\r\n        fill-opacity: .25;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke-width: 2.01px;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient);\r\n        stroke-width: .82px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.16,
    y1: 45.21,
    x2: 71.81,
    y2: 45.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    y1: 49.04,
    x2: 9.05,
    y2: 49.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.05,
    x2: 15.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 71.76,
    y1: 49.04,
    x2: 77.96,
    y2: 49.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 77.96,
    y1: 49.04,
    x2: 85.5,
    y2: 49.04,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m15.16,46.12c0,17.51,14.9,31.7,28.32,31.7s28.32-14.19,28.32-31.7-7.12-33.52-28.32-33.52S15.16,28.61,15.16,46.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.7,92.37c-2.26,0-4.44-.9-6.04-2.5s-2.5-3.78-2.5-6.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m39.29,97.94c-3.64,0-7.12-1.45-9.69-4.02-2.57-2.57-4.02-6.06-4.02-9.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.04,102.86c-4.87,0-9.55-1.94-13-5.38-3.45-3.45-5.38-8.13-5.38-13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m6.54,39.74v-1.76C6.54,17.55,23.11,1.01,43.51,1.01s36.97,16.55,36.97,36.97v1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m47.78,81.32c23.49-.96,27.17-8.33,27.65-20.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.02,39.74h4.02v18.61h-3.93c-2.27,0-4.11-1.84-4.11-4.11v-10.34c0-2.3,1.81-4.15,4.02-4.15h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 9.05,
    y: 37.22,
    width: 6.2,
    height: 23.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 71.76,
    y: 37.22,
    width: 6.2,
    height: 23.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.48,58.35h-3.52v-18.61h3.52c2.22,0,4.02,1.86,4.02,4.15v10.3c0,2.3-1.81,4.15-4.02,4.15h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 36.21,
    y: 78.47,
    width: 11.57,
    height: 6.04,
    rx: 2.66,
    ry: 2.66
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSolicitors);
export default __webpack_public_path__ + "static/media/noSolicitors.a9951e621093bb5046c73b324e9c2bcf.svg";
export { ForwardRef as ReactComponent };